import { displayElement } from "./display";

function checkIfFieldRequired(field, state, values, globalState) {
  // check if the field is required and whether the field is to be displayed by checking for set values either in the saved state or the current values
  const required = field.checkIfRequiredFromValues
    ? field.checkIfRequiredFromValues(values)
    : field.required;

  return (
    required && displayElement(field, state, values, globalState)
  );
}

function checkIfRequiredFieldValueValid(field, values) {
  //If values[field.name] is equal to 0 then the first part of the OR in this if statement will fail
  //This is not good for a picklist where one of the options has a value of 0
  //So the check on the second part of the OR is to handle that sitaution
  //This is the same case if values[field.name] is equal to false for a field of type bit
  //so the third part handles that. This is to prevent the default value from being set on the field
  //when the value should be the values value of false

  return (
    values[field.name] ||
    (["decimal", "int", "money", "picklist"].includes(field.type) &&
      values.hasOwnProperty(field.name) &&
      values[field.name] === 0) ||
    (field.type === "bit" &&
      values.hasOwnProperty(field.name) &&
      values[field.name] !== null &&
      values[field.name].toString() === "false")
  );
}

function validateFormStage(globalState, stages, state, values) {
  const errors = {};

  stages.forEach((stage) => {
    stage.sections
      .filter((section) => section.fields)
      .forEach((section) => {
        section.fields.forEach((field) => {
          if (
            checkIfFieldRequired(field, state, values, globalState) &&
            !checkIfRequiredFieldValueValid(field, values)
          ) {
            errors[field.name] = "Required";
          } else if (field.validate) {
            const error = field.validate(
              values[field.name],
              values,
              state
            );
            if (
              error &&
              (!Array.isArray(error) || error.length > 0)
            ) {
              errors[field.name] = error;
            }
          }
        });
      });
  });

  return errors;
}

export {
  checkIfFieldRequired,
  checkIfRequiredFieldValueValid,
  validateFormStage,
};
